import React from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDate } from '../../utils/helpers';

export function DashboardMobile({ vm }) {
  const { event, cards, isMarriage } = vm;
  const navigate = useNavigate();
  return (
    <div className="dashboard-mobile ev-dash-m">
      <div className="dash-kpi-grid">
        {cards.map((c, i) => (
          <button
            key={i}
            type="button"
            className={`kpi-card kpi-link dash-kpi ${c.tone ? `tone-${c.tone}` : ''}`}
            onClick={() => c.to && navigate(c.to)}
          >
            <div className="kpi-card-top">
              <span className="kpi-badge">{String(c.l || '').slice(0, 1)}</span>
              <span className="kpi-index">{String(i + 1).padStart(2, '0')}</span>
            </div>
            <div className="n">{c.n}</div>
            <div className="l">{c.l}</div>
          </button>
        ))}
      </div>

      {event && (
        <div className="card card-pad mobile-record-card event-summary-card">
          <div className="event-summary-head">
            <div>
              <div className="muted">Current event</div>
              <strong className="mobile-title">{event.EventName}</strong>
            </div>
            <span className="event-type-pill">{event.EventTypeName || event.EventType || 'Event'}</span>
          </div>
          <div className="mobile-meta">
            <div className="muted">
              {fmtDate(event.EventStartDate)} to {fmtDate(event.EventEndDate)}
            </div>
            {(event.Venue || event.City) && (
              <div className="muted">📍 {[event.Venue, event.City].filter(Boolean).join(', ')}</div>
            )}
            {isMarriage && (
              <div className="event-side-row">
                <span className="chip male">Groom: {event.MaleSideName || '-'}</span>
                <span className="chip female">Bride: {event.FemaleSideName || '-'}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
